import React, { PureComponent } from "react";
import i18n from "@/i18n";
import { func } from "prop-types";
import { map, list } from "react-immutable-proptypes";
import { getUserName } from "../../../components/helpers/users";

import { ItemList, ItemListColumn, ItemListRow } from "@/components/itemList";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

const { t } = i18n;

export default class NotifyAboutSignedDoc extends PureComponent {
  static propTypes = {
    shareWith: map,
    investors: list,
    usersCache: map,
    onDeleteUser: func,
  };

  render = () => {
    const { shareWith } = this.props;

    return (
      <ItemList columnSizing="4fr 1fr">
        {shareWith
          .toList()
          .map((userToNotify) => {
            const { usersCache, investors, onDeleteUser } = this.props;
            const name = getUserName(userToNotify, investors, usersCache);
            const userId = userToNotify.get("userId");
            const avatarType = investors
              .get(userToNotify.get("investmentId"))
              ?.get("investorTypeOfOwner");

            return (
              <ItemListRow key={userId} rightAlignLastColumn>
                <ItemListColumn.Avatar
                  id={userId}
                  name={name}
                  avatarType={avatarType}
                />
                <ItemListColumn>
                  <Button
                    onClick={onDeleteUser.bind(null, userToNotify)}
                    variant="ghost"
                  >
                    <X size={16} /> {t("generic.remove")}
                  </Button>
                </ItemListColumn>
              </ItemListRow>
            );
          })
          .toJS()}
      </ItemList>
    );
  };
}
